import React from "react";
import "./Stylesheets/App.css";
import "./Stylesheets/neo.css";
import Footer from "./Components/Footer";
import NavigationBar from "./NavigationBar/NavigationBar";
import axios from "axios";
import { BASE_URL } from "./Constants";
import LoadingSpinner from "./LoadingSpinner";
import ConfirmationView from "./ConfirmationView";
import NeoButton from "./Button/NeoButton";
import Cookies from "js-cookie";
import ErrorBox from "./Components/ErrorBox";
import NeoEditField from "./EditField/NeoEditField";

class VendorUploadData extends React.Component {
    state = {
        errorMessage: null,
        errors: null,
        isSending: false,
        isSent: false,
        handover_date: new Date(),
        deliver_date: new Date(),
        deliverCode: "",
        frameNumber: "",
        abholer: "",
        ausweisnummer: "",
        akkunummer: ""
    };

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.sendOffer = this.sendOffer.bind(this);
    }

    render() {
        const { id } = this.props.match.params;

        return (
            <div className="neo-app">
                <NavigationBar title="Daten ergänzen" />

                <div className="neo-content">
                    {this.state.isSent ? (
                        <ConfirmationView
                            text="Deinen Daten wurden erfolgreich gespeichert."
                            icon="confirmation.png"
                            route={"/vendor/offers/" + id}
                        />
                    ) : (
                        this.Data()
                    )}
                </div>

                <Footer />
            </div>
        );
    }

    LoadingView() {
        return <LoadingSpinner title="Laden..." />;
    }

    chooseFile() {
        this.state.inputElement.click();
    }

    handleChange(event) {
        const value = event.target.value;

        this.setState({
            ...this.state,
            [event.target.name]: value,
            errors: [],
        });

        if (event.target.name === "objectPrice") {
            this.setState({ rate: 0, insurance_fee: 0, insurance_available: null });
        }
    }

    ErrorsView() {
        const { errors } = this.state;
        const { errorMessage } = this.state;

        return errorMessage !== null ? (
            <ErrorBox errorMessage={errorMessage} errors={errors} />
        ) : null;
    }

    sendOffer() {
        const { id } = this.props.match.params;

        if(this.state.frameNumber == "" || this.state.handover_date == "" || this.state.deliver_date == "") {
            this.setState({
                errorMessage: "Fehler",
            })

            let errors = [];
            if(this.state.frameNumber == "") {
                errors.push("Rahmennummer ist ein Pflichtfeld.");
            }

            if(this.state.deliver_date == "") {
                errors.push("Lieferdatum ist ein Pflichtfeld.");
            }

            if(this.state.handover_date == "") {
                errors.push("Übergabedatum ist ein Pflichtfeld.");
            }

            this.setState({
                errors: errors,
            })
            return false
        }else{
            this.setState({
                errorMessage: "",
            })
        }

        this.setState({ isSending: true });

        let branchID = Cookies.get("CurrentStoreID");

        axios
            .post(
                BASE_URL +
                (this.state.useCompanyGroup
                    ? "/vendor/offer-update/company/"+id
                    : "/vendor/offer-update/"+id),
                {
                    handover_date: this.state.handover_date,
                    deliver_date: this.state.deliver_date,
                    deliver_code: this.state.deliverCode,
                    frame_number: this.state.frameNumber,
                    ausweisnummer: this.state.ausweisnummer,
                    akkunummer: this.state.akkunummer,
                    abholer: this.state.abholer,
                    branch_id: branchID,
                }
            )
            .then(() => {
                this.setState({ isSending: false, isSent: true });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        isSending: false,
                        errors: error.response.data.errors,
                        errorMessage: error.response.data.message,
                    });
                }
            });
    }

    Data() {
        return (
            <div>
                <p className="neo-mediumTitle" id="leading">
                    Daten ergänzen
                </p>
                <p className="neo-text" id="leading">
                    Hier können Sie Lieferdatum, den Liefercode, die Rahmennummer und den Übergabedatum festlegen
                </p>

                <input
                    type="text"
                    placeholder="Abholername"
                    name="abholer"
                    value={this.state.abholer}
                    onChange={this.handleChange}
                />

                <input
                    type="text"
                    placeholder="Personalausweisnummer"
                    name="ausweisnummer"
                    value={this.state.ausweisnummer}
                    onChange={this.handleChange}
                />

                <input
                    type="text"
                    placeholder="Liefercode vom Kunden"
                    name="deliverCode"
                    value={this.state.deliverCode}
                    onChange={this.handleChange}
                />

                <input
                    type="text"
                    placeholder="Rahmennummer"
                    name="frameNumber"
                    value={this.state.frameNumber}
                    onChange={this.handleChange}
                />

                <input
                    type="text"
                    placeholder="Akkunummer"
                    name="akkunummer"
                    value={this.state.akkunummer}
                    onChange={this.handleChange}
                />

                <p>Lieferdatum</p>
                <NeoEditField
                    label=""
                    type="date"
                    name="deliver_date"
                    value={this.state.deliver_date ?? ""}
                    onChange={this.handleChange}
                />

                <p>Übergabedatum</p>
                <NeoEditField
                    label=""
                    type="date"
                    name="handover_date"
                    value={this.state.handover_date ?? ""}
                    onChange={this.handleChange}
                />

                <div className="neo-spacer20" />

                <div className="neo-divider" />

                <div className="neo-spacer20" />

                {this.ErrorsView()}

                <NeoButton
                    title="Speichern"
                    showLoadingState={this.state.isSending}
                    onClick={this.sendOffer}
                />
            </div>
        );
    }
}

export default VendorUploadData;
